import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

// Access control for loyalty domain pages:
// - Internal users: always have access with internal permissions
// - External users: require external permissions AND SFX R2 release version
export const loyaltyAccessControl: DomainAccessControlConfig = [
  // Internal users - no version restriction
  {
    permissions: [Permission.LoyaltyProgramInternalView, Permission.LoyaltyProgramInternalModify],
  },
  // External users - require SFX R1 release version
  {
    permissions: [Permission.LoyaltyProgramView, Permission.LoyaltyProgramModify],
    minICPlatformVersion: ICPlatformVersion.r2026_02_0,
    restrictedBannersAllowed: true,
  },
]
